import React from 'react';
import styles from './ProgressCircle.module.css';

const ProgressCircle = ({
    percentage,
    total,
    current,
    size = 60,
    strokeWidth = 6,
    color = '#4CAF50'
}) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    const isSegmented = total > 0 && total < 100;
    const displayPercentage = percentage !== undefined ? percentage : (total > 0 ? (current / total) * 100 : 0);

    // Recalculate styles based on logic
    let trackStyle = {};
    let progressStyle = { stroke: color };

    if (isSegmented) {
        const gap = 4;
        const segmentLength = (circumference - (total * gap)) / total;

        if (segmentLength > 0) {
            // Track shows all segments
            trackStyle = { strokeDasharray: `${segmentLength} ${gap}` };

            // Progress shows filled segments
            // We build the dashArray manually to ensure it doesn't repeat incorrectly
            const segments = [];
            for (let i = 0; i < Math.floor(current); i++) {
                segments.push(segmentLength);
                segments.push(gap);
            }

            // Add partial segment if any
            const partial = current % 1;
            if (partial > 0) {
                segments.push(segmentLength * partial);
                segments.push(gap + (segmentLength * (1 - partial)));
            }

            // Always ensure we have an even number of elements and the last is a gap
            // and that it covers the rest of the circumference
            segments.push(0);
            segments.push(circumference);

            progressStyle = {
                stroke: color,
                strokeDasharray: segments.join(' '),
                strokeDashoffset: 0
            };
        }
    } else {
        // Continuous mode
        const continuousDashArray = `${circumference} ${circumference}`;
        const continuousDashOffset = circumference - (displayPercentage / 100) * circumference;

        progressStyle = {
            stroke: color,
            strokeDasharray: continuousDashArray,
            strokeDashoffset: continuousDashOffset
        };
    }

    return (
        <div className={styles.circleContainer} style={{ width: size, height: size }}>
            <svg className={styles.svg}>
                <circle
                    className={styles.circleTrack}
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    strokeWidth={strokeWidth}
                    style={trackStyle}
                />
                <circle
                    className={styles.circleProgress}
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    strokeWidth={strokeWidth}
                    style={progressStyle}
                />
            </svg>
            <div className={styles.percentageText} style={{ fontSize: size * 0.25 }}>
                {Math.round(displayPercentage)}%
            </div>
        </div>
    );
};

export default ProgressCircle;
